/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { setOrderDetails } from 'actions/orderDetailsAction';
import FSBModal from 'components/common/FSBModal';
import OrderDetails from './components/OrderDetails';

const OrderDetailsDrawer = () => {
  const dispatch = useDispatch();
  const { status, selectedOrder } = useSelector(
    (state) => state.orderDetailsReducer,
  );
  const drawerToggle = () => {
    dispatch(setOrderDetails({ status: false, selectedOrder: null }));
  };

  useEffect(() => {
    dispatch(setOrderDetails({ status: false, selectedOrder: null }));
  }, []);

  useEffect(() => {
    const handlePopState = () => {
      drawerToggle();
    };

    window.addEventListener('popstate', handlePopState);

    return () => {
      window.removeEventListener('popstate', handlePopState);
    };
  }, []);

  return (
    <div>
      {' '}
      {status && (
        <FSBModal
          open={status}
          size="xl"
          title="Order Details"
          closeButtonLabel=""
          confirmButtonLabel=""
          message=""
          toggleAlert={drawerToggle}
          onClose={drawerToggle}
          onConfirmClick={drawerToggle}
          modalClass="right-drawer right-drawer-details"
        >
          <OrderDetails orderId={selectedOrder.id} />
        </FSBModal>
      )}
    </div>
  );
};

export default OrderDetailsDrawer;
